/* import React from "react";
import { Outlet } from "react-router-dom";
import NavBa from "../NavBa";
import Footer from "../Footer";

const Layout = () => {
  return (
    <>
      {" "}
      <NavBa /> <Outlet /> <Footer />{" "}
    </>
  );
};
export default Layout; */

// pages/Layout.js
import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavBa from "../NavBa";
import Footer from "../Footer";
import Drawer from "../Drawer";
import Button from "react-bootstrap/Button";
import { useLanguage } from "../Context";

const Layout = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const [showDrawer, setShowDrawer] = useState(false);
  const { language } = useLanguage();

  const toggleDrawer = () => setShowDrawer(!showDrawer);

  return (
    <>
      <NavBa />
      {!isHomePage && (
        <>
          <Button
            variant="primary"
            onClick={toggleDrawer}
            style={{ margin: 10 }}
          >
            {language === "fi" ? "Valikko" : "Menu"}
          </Button>
          <Drawer
            show={showDrawer}
            handleClose={() => setShowDrawer(false)}
            language={language}
          />
        </>
      )}
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;
